import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import {
    TimerOutlined as TimerIcon,
    CheckCircleOutlined as CheckIcon,
    RadioButtonUnchecked as PendingIcon,
    TrendingDown as TrendingDownIcon,
    TrendingUp as TrendingUpIcon,
} from '@material-ui/icons'
import strings from 'strings'
import { formatHrs } from './udHelpers'

const UDStatCards = ({ stats, pending, range, slaHours, classes }) => {
    const avgCycleColor = (stats.avgCycleHrs == null || slaHours == null)
        ? undefined
        : stats.avgCycleHrs <= slaHours ? 'var(--status-approved)' : 'var(--status-declined)'

    const stuck = stats.checksStuckOver24h || 0
    const pendingIconColor = stuck > 0 ? 'var(--rox-orange-ink)' : 'var(--fg-tertiary)'

    return (
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12} md={4}>
                <Box className={classes.statCard} display="flex" flexDirection="column">
                    <Box className={classes.statHead}>
                        <Box className={classes.statIcon}><TimerIcon /></Box>
                        <Typography className={classes.statLabel}>{strings.UD.AVG_CYCLE_TIME}</Typography>
                    </Box>
                    {stats.avgCycleHrs == null ? (
                        <Typography className={classes.statNoData}>{strings.UD.NO_DATA}</Typography>
                    ) : (
                        <Box display="flex" alignItems="baseline">
                            <Typography className={classes.statValue} style={avgCycleColor ? { color: avgCycleColor } : undefined}>{formatHrs(stats.avgCycleHrs)}</Typography>
                            <Typography className={classes.statUnit}>{strings.UD.HRS}</Typography>
                        </Box>
                    )}
                    <Typography className={classes.statSub}>{strings.UD.FROM_NEW_TO_DECISION}</Typography>
                    {stats.avgCycleDeltaHrs != null && (
                        <Box mt="auto" pt={1}>
                            <Typography
                                className={classes.statChange}
                                style={{ color: stats.avgCycleDeltaHrs === 0 ? 'var(--fg-tertiary)' : stats.avgCycleDeltaHrs < 0 ? 'var(--status-approved)' : 'var(--status-declined)' }}
                            >
                                {stats.avgCycleDeltaHrs <= 0
                                    ? <TrendingDownIcon style={{ fontSize: 14 }} />
                                    : <TrendingUpIcon style={{ fontSize: 14 }} />}
                                {' '}{formatHrs(Math.abs(stats.avgCycleDeltaHrs))}h
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Grid>
            <Grid item xs={12} md={4}>
                <Box className={classes.statCard} display="flex" flexDirection="column">
                    <Box className={classes.statHead}>
                        <Box className={classes.statIcon}><CheckIcon /></Box>
                        <Typography className={classes.statLabel}>{strings.UD.CHECKS_COMPLETED}</Typography>
                    </Box>
                    <Box display="flex" alignItems="baseline">
                        <Typography className={classes.statValue}>{stats.checksCompleted || 0}</Typography>
                        <Typography className={classes.statUnit}>{strings.UD.THIS_RANGE.replace('{range}', range)}</Typography>
                    </Box>
                    <Typography className={classes.statSub}>{strings.UD.ACROSS_APPLICATIONS.replace('{count}', pending.length)}</Typography>
                    {stats.checksCompletedDelta != null && stats.checksCompletedDelta !== 0 && (
                        <Box mt="auto" pt={1}>
                            <Typography
                                className={classes.statChange}
                                style={{ color: stats.checksCompletedDelta > 0 ? 'var(--status-approved)' : 'var(--status-declined)' }}
                            >
                                {stats.checksCompletedDelta >= 0
                                    ? <TrendingUpIcon style={{ fontSize: 14 }} />
                                    : <TrendingDownIcon style={{ fontSize: 14 }} />}
                                {' '}{Math.abs(stats.checksCompletedDelta)}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Grid>
            <Grid item xs={12} md={4}>
                <Box className={classes.statCard} display="flex" flexDirection="column">
                    <Box className={classes.statHead}>
                        <Box className={classes.statIcon} style={{ color: pendingIconColor }}><PendingIcon /></Box>
                        <Typography className={classes.statLabel}>{strings.UD.CHECKS_PENDING}</Typography>
                    </Box>
                    <Box display="flex" alignItems="baseline">
                        <Typography className={classes.statValue}>{stats.checksPending || 0}</Typography>
                        <Typography className={classes.statUnit}>{strings.UD.ACROSS_APPS.replace('{count}', stats.checksPendingApps || 0)}</Typography>
                    </Box>
                    <Typography className={classes.statSub}>{strings.UD.STAT_STUCK.replace('{count}', stuck)}</Typography>
                </Box>
            </Grid>
        </Grid>
    )
}

export default UDStatCards
